module.exports = __webpack_public_path__ + "static/OnPay-ee2d3f77e345dc894bef970a57abf7c2.jpg";